// Atlas Shared Constants — System limits, status labels, and configuration values
// These are used across the API, dashboard, and extension for consistency.

// ─── Gmail limits (verified August 2026) ───
export const GMAIL_SEND_LIMIT_DAILY = 500;
export const GMAIL_SEND_LIMIT_WARNING = 450; // Warn at 90% of limit
export const GMAIL_API_RATE_LIMIT_PER_MINUTE = 6000;
export const GMAIL_MESSAGE_SEND_COST = 100; // quota units per send

// ─── Cloudflare Workers limits (verified August 2026) ───
export const WORKERS_REQUESTS_DAILY = 100_000;
export const WORKERS_REQUESTS_WARNING = 80_000; // Warn at 80%
export const WORKERS_CPU_LIMIT_MS = 10;
export const D1_STORAGE_LIMIT_BYTES = 5 * 1024 * 1024 * 1024; // 5 GB
export const D1_ROWS_READ_DAILY = 5_000_000;
export const D1_ROWS_WRITTEN_DAILY = 100_000;
export const R2_STORAGE_LIMIT_BYTES = 10 * 1024 * 1024 * 1024; // 10 GB
export const KV_STORAGE_LIMIT_BYTES = 1024 * 1024 * 1024; // 1 GB

// ─── Tracking engine constants ───
export const OPEN_DEDUP_WINDOW_SECONDS = 1; // De-duplicate opens within 1 second
export const OPEN_DEDUP_WINDOW_MS = OPEN_DEDUP_WINDOW_SECONDS * 1000;
export const PIXEL_SIZE = 1; // 1x1 pixel
export const TRACKING_ID_LENGTH = 32; // Characters in tracking IDs

// ─── Campaign pacing (milliseconds between sends) ───
export const CAMPAIGN_PACING = {
  fast: 10_000, // 1 email per 10 seconds (360/hour)
  normal: 30_000, // 1 email per 30 seconds (120/hour)
  slow: 120_000, // 1 email per 2 minutes (30/hour)
} as const;

// ─── Cron schedules ───
export const CRON_SCHEDULES = {
  scheduledSends: "* * * * *", // Every minute
  replyDetection: "*/15 * * * *", // Every 15 minutes
  weeklyReport: "0 8 * * 1", // Monday 8:00 AM (UTC — IST is +5:30, so this is 2:30 PM IST; adjusted in cron handler)
  monthlyReport: "0 8 1 * *", // 1st of month 8:00 AM UTC
  healthCleanup: "*/5 * * * *", // Every 5 minutes
} as const;

// ─── Reply detection ───
export const REPLY_DETECTION_INTERVAL_MINUTES = 15;
export const REPLY_OVERDUE_MULTIPLIER = 2.5; // Overdue at 2.5x normal reply time
export const REPLY_OVERDUE_DEFAULT_DAYS = 14; // Default if not enough history
export const MIN_CONTACTS_FOR_TREND = 3; // Minimum interactions for trend computation

// ─── Engagement trend thresholds ───
export const ENGAGEMENT_TREND_WINDOW_DAYS = 30;
export const ENGAGEMENT_TREND_MEANINGFUL_CHANGE = 0.15; // 15% change is meaningful

// ─── Conversation states ───
export const CONVERSATION_ENDED_INACTIVITY_DAYS = 30;

// ─── Health monitoring ───
export const HEALTH_CHECK_INTERVAL_MINUTES = 5;
export const HEALTH_CHECK_RETENTION_DAYS = 30;
export const NOTIFICATION_RETENTION_DAYS = 90;

// ─── Storage limits for retention ───
export const FILE_RETENTION_DEFAULT_DAYS = 90;
export const TRACKING_EVENT_RETENTION_DEFAULT_DAYS = 365;

// ─── Timezone ───
export const FOUNDER_TIMEZONE = "Asia/Calcutta";
export const IST_OFFSET_MINUTES = 330; // UTC+5:30

// ─── Notification de-duplication ───
export const NOTIFICATION_DEDUP_WINDOW_MINUTES = 60; // 1 hour

// ─── Extension constants ───
export const EXTENSION_BADGE_REFRESH_INTERVAL_MS = 120_000; // 2 minutes
export const EXTENSION_HEARTBEAT_INTERVAL_MS = 300_000; // 5 minutes
